// extracted by mini-css-extract-plugin
export default {"cls1":"ResearcherList-cls1__b2f8180a10e6bbd1488d","cls2":"ResearcherList-cls2___f37194712b3bdddaedf ResearcherList-cls1__b2f8180a10e6bbd1488d"};